<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3">
        <div class="vx-col w-full mt-base">
          <vx-card class="p-2">
            <vs-avatar
              class="mx-auto my-6 block"
              size="80px"
              :src="avatar"
            />
            <div class="text-center">
              <h5>{{pengguna.nama}}</h5>
            </div>
            <vs-button
              class="w-full mt-6"
              color="primary"
              type="border"
              size="small"
              icon-pack="feather"
              icon="icon-edit"
              @click="$refs.dialogAvatar.toggleActive(true)"
              >Update Avatar
            </vs-button>
          </vx-card>

          <HakAkses 
            :pengguna="pengguna" 
            @submitCallback="refreshPenggunaQuery()"
          />
        </div>
      </div>

      <div class="vx-col w-full lg:w-2/3">
        <div class="vx-col w-full mt-base">
          <vx-card class="mt-base">
            <div class="w-full flex flex-col">
              <div class="w-full relative">
                <div class="flex w-full  justify-between items-center">
                  <div class="text-xl flex-1 flex flex-col ">
                    <div class="font-semibold">Detail Pegawai</div>
                  </div>
                  <div class="flex">
                    <div
                      class="flex items-center cursor-pointer shadow px-4 py-2 rounded-lg mx-3"
                      @click="$router.push({name: 'manajemen-user-edit', params: {uuid: $route.params.uuid }})"
                    >
                      <feather-icon icon="EditIcon" class="mr-3"></feather-icon>
                      <div>Update Pegawai</div>
                    </div>
                    <div
                      class="flex items-center cursor-pointer  shadow px-4 py-2 rounded-lg mx-3"
                      @click="$router.push({name: 'manajemen-user-edit-credentials', params: {uuid: $route.params.uuid }})"
                    >
                      <feather-icon icon="EditIcon" class="mr-3"></feather-icon>
                      <div>Update Kredensial</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <h6>&nbsp;</h6>
            </div>
            <div class="mt-5">
              <h6>Nama :</h6>
              <p>{{pengguna.nama}}</p>
            </div>
            <div class="mt-5">
              <h6>Username :</h6>
              <p>{{pengguna.login.username}}</p>
            </div>
            <div class="mt-5">
              <h6>NIP :</h6>
              <p>{{pengguna.nip}}</p>
            </div>
            <div class="mt-5">
              <h6>Jabatan & Golongan :</h6>
              <p>{{pengguna.jabatan.nama + ' - ' + pengguna.golongan.nama}}</p>
            </div>
            <div class="mt-5">
              <h6>Bidang :</h6>
              <p>{{pengguna.jabatan.bidang.nama}}</p>
            </div>
            <div class="mt-5">
              <h6>Telepon :</h6>
              <p>{{pengguna.telepon}}</p>
            </div>
            <div class="mt-5">
              <h6>Alamat :</h6>
              <p>{{pengguna.alamat}}</p>
            </div>
            <div class="mt-5">
              <h6>Tanggal Lahir :</h6>
              <p>{{pengguna.tgl_lahir}}</p>
            </div>
            <div class="mt-5">
              <h6>TTD Image :</h6> <br>
              <vs-button
                  @click="$refs.dialogTtd.toggleActive(true)"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="mb-4 self-end"
                  size="small"
                > {{pengguna.ttd == null ? 'Tambah TTD Image' : 'Update TTD Image'}}
              </vs-button>
            </div>
            <div class="mt-5">
              <h6>Sertifikat P12 :</h6> <br>
              <vs-button
                  @click="$refs.dialogSertifikat.toggleActive(true)"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="mb-4 self-end"
                  size="small"
                > {{pengguna.ttd == null ? 'Tambah Sertifikat' : 'Update Sertifikat'}}
              </vs-button>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <br>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4">
        <vs-button
            @click="$router.push({name: 'manajemen-user'})"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-arrow-left"
            class="mb-4 self-end"
            size="small"
          > Kembali
        </vs-button>
      </div>
    </div>

    <DialogSertifikat
      ref="dialogSertifikat"
      :penggunaId="pengguna.id"
      :dokumen="[]"
      @submitCallback="refreshPenggunaQuery"
    />
    <DialogTtd
      ref="dialogTtd"
      :penggunaId="pengguna.id"
      :dokumen="[]"
      @submitCallback="refreshPenggunaQuery"
    />
    <DialogAvatar
      ref="dialogAvatar"
      :penggunaId="pengguna.id"
      :dokumen="[]"
      @submitCallback="refreshPenggunaQuery"
    />
</div>
</template>

<script>
import { FIND } from '@/query/pengguna';
import DialogSertifikat from "./components/DialogSertifikat"; 
import DialogTtd from "./components/DialogTtd";
import DialogAvatar from "./components/DialogAvatar";
import HakAkses from "./components/HakAkses";

export default {
  components: {
    DialogSertifikat,
    DialogTtd,
    DialogAvatar,
    HakAkses
  },
  data() {
    return {
      pengguna : {
        id : '',
        login : {},
        jabatan : {
          bidang : {}
        },
        golongan : {}
      },
      url : process.env.VUE_APP_DIGOF_URL+'storage/',
    };
  },
  computed: {
    avatar() {
      if (this.pengguna.avatar !== null)
        return `${process.env.VUE_APP_DIGOF_URL}sources/${this.pengguna.avatar}`;
      else
        return "https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-2/img/13-small.d796bffd.png";
    }
  },
  apollo : {
    pengguna : {
      query : FIND,
      update : (data) => data.pengguna,
      variables(){
        return {
          where: { column : 'UUID', value : this.$route.params.uuid }
        }
      },
      fetchPolicy: "cache-and-network",
    },
  },
  methods : {
    refreshPenggunaQuery(){
      this.$apollo.queries.pengguna.refetch();
    }
  },
};
</script>